(function($) {
    $(document).ready(function() {

        // function adjustBodyPaddingTop() {
        //     var headerHeight = $('header nav').outerHeight();
        //     $('body').css('padding-top', headerHeight);
        // }

        // function onResize() {
        //     adjustBodyPaddingTop();
        // }

        // onResize();

        // $(window).resize(function() {
        //     onResize();
        // });

        // handle menu
        function handleNav(itemClicked) {
            console.log('**********handleNav');
            
            var activeDropdown = $('#main-menu > .dropdown-menu');
            var currentPageNotInActiveDropdown = activeDropdown.find('.nav-item.current_page_item').length === 0;
    
            activeDropdown.find('.nav-item a').each(function() {
                $(this).removeClass('active-item');
            });
        
            if(currentPageNotInActiveDropdown){
                // show preview of first menu item
                activeDropdown.find('.nav-item:nth-of-type(1) a').addClass('active-item');
            } else {
                // show preview of current page item
                activeDropdown.find('.nav-item.current_page_item a').addClass('active-item');
            };
        
            // show preview of last hovered item
            activeDropdown.find('.nav-item a').hover(
                function() {
                    activeDropdown.find('.nav-item a').each(function() {
                        $(this).removeClass('active-item');
                    });
                    
                    $(this).addClass('active-item');
    
                    if(!currentPageNotInActiveDropdown){
                        // remove current page item indicator
                        $('.current_page_item > .dropdown-item').css('border-bottom-color', 'transparent');
                    }
                }
            );
        };
    
    
        function setupMenu() {
                
            // reset event listeners
            $('#main-menu > .menu-item > a').off('mouseenter mouseleave');
            $('#main-menu > .dropdown-menu').off('mouseleave');
            $('#page div:not(.stickyHeader)').off('click');
            $('#main-menu > .menu-item').off('click');
            $('#main-nav .navbar-toggler').off('click');
            $('#main-menu-mobile > .menu-item .dropdown-toggle').off('click');
    
        
            if (window.innerWidth >= 992) {
                $('#main-menu > .menu-item > a').hover(function() {
                    handleNav(this);
                    $('#main-menu > .menu-item a').removeClass('show');
                    $('#main-menu > .dropdown-menu').removeClass('show');
                    $(this).addClass('show');
                    $('#main-menu > .dropdown-menu').addClass('show');
                });
        
                $('#main-menu > .dropdown-menu').on('mouseleave', function(e) {
                    $('#main-menu > .menu-item a').removeClass('show');
                    $(this).removeClass('show');
                });
        
                $('#page div:not(.stickyHeader)').on('click', function(e) {
                    $('#main-menu > .menu-item a').removeClass('show');
                    $('#main-menu > .dropdown-menu').removeClass('show');
                });
            } else {
                // handle mobile menu toggle
                $('#main-nav .navbar-toggler').on('click', function () {
                    var $button = $(this);
                    var target = $button.data('target');
                    var $menu = $(target);
                    var $overlay = $('.overlay');
            
                    if ($button.hasClass('collapsed')) {
                        $menu.removeClass('hide').addClass('show');
                        $button.removeClass('collapsed').attr('aria-expanded', 'true');
                        $overlay.addClass('d-block');
                        $menu.trigger('show');
                        $menu.find('.navbar-nav').children().each(function() {
                            var element = $(this);
                            
                            if (element.hasClass('current_page_parent') && !element.find('.dropdown-toggle').hasClass('active-item')) {
                                element.find('.dropdown-toggle').addClass('active-item');
                                element.find('.sub-menu').addClass('show');
                            }
                        });
                    } else {
                        // Hide the menu
                        $menu.removeClass('show').addClass('hide');
                        $button.addClass('collapsed').attr('aria-expanded', 'false');
                        $menu.trigger('hide');
                        $overlay.removeClass('d-block');
                    }
                });

                $('#main-menu-mobile > .menu-item .dropdown-toggle').on('click', function(e) {
                    $('#main-menu-mobile > .menu-item .dropdown-toggle').not(this).removeClass('active-item');
                    $(this).toggleClass('active-item');
                    var $submenu = $(this).parent().siblings('.sub-menu');
                    $('#main-menu-mobile .sub-menu').not($submenu).removeClass('show');
                    $submenu.toggleClass('show');
                });
                
            }
        }
        
        setupMenu();
        $(window).resize(setupMenu);


        // play video in banner
        $('.play-video').on('click', function(){
            var video = $(this).closest('.video-banner').find('video')[0];
            
            if(video) {
                video.play();
            }
        });


        // handle searchandfilter category
        $('.searchandfilter_set_category').each(function() {
            var categoryElement = $(this);
            
            var categoryClass = categoryElement.attr('class').match(/category_([a-zA-Z0-9_-]+)/);
            if (categoryClass && categoryClass[1]) {
                var categoryValue = categoryClass[1];
                var formattedCategory = categoryValue.replace(/-/g, ' ').replace(/\b\w/g, function(l){ return l.toUpperCase(); });
                var selectElement = categoryElement.find('#ofcategory');
    
                if (selectElement.length) {
                    selectElement.find('option').each(function() {
                        var optionText = $(this).text().trim();
                        if (optionText === formattedCategory) {
                            $(this).prop('selected', true);
                            return false;
                        }
                    });
                }
            }
        });


        // publications-presentations tabs

        // if ($('body').hasClass('page-id-5070')) {
        //     var activeTab = sessionStorage.getItem('activeTab') || window.location.hash.substring(1);
        //     $('.loading-spinner').removeClass('d-none'); 
        //     $('.loading-spinner').addClass('d-flex');
    
        //     $('#tab-publications, #tab-presentations').on('click', function(e) {
        //         e.preventDefault();
        //         $('.tab-pane').addClass('d-none');
        //         $('.loading-spinner').removeClass('d-none'); 
        //         $('.loading-spinner').addClass('d-flex');
    
        //         var tabName = $(this).attr('id').replace('tab-', '');
        //         sessionStorage.setItem('activeTab', tabName);

        //         var urlWithoutSearch = window.location.protocol + '//' + window.location.host + window.location.pathname;
        //         window.location.assign(urlWithoutSearch + '#' + tabName);
    
        //         if (window.location.search === '') {
        //             location.reload();
        //         }
        //     });
    
        //     if (activeTab) {
        //         setTimeout(function() {
        //             $('.loading-spinner').removeClass('d-flex'); 
        //             $('.loading-spinner').addClass('d-none');
        //             $('.tab-pane').removeClass('active');
        //             $('.tab-pane').addClass('d-none');        
        //             $('.aveo-tabs-btns button').removeClass('active');
        //             $('#tab-' + activeTab).addClass('active');
        //             $('#' + activeTab).removeClass('d-none');
        //         }, 500);
        //     } else {
        //         setTimeout(function() {
        //             $('.loading-spinner').removeClass('d-flex'); 
        //             $('.loading-spinner').addClass('d-none');
        //             $('.aveo-tabs .tab-pane:first-of-type').removeClass('d-none');
        //             $('.aveo-tabs-btns button:first-of-type').addClass('active');

        //         }, 500);
        //     }

        //     // scroll if viewing paginated results
        //     setTimeout(function() {
        //         var isNotOnFirstPage = false;
        //         $('.wp-block-query-pagination-numbers [aria-current="page"]').each(function() {
        //             if ($(this).text() !== '1') {
        //                 isNotOnFirstPage = true;
        //             }
        //         });
    
        //         if (isNotOnFirstPage) {
        //             var headerHeight = $('header').outerHeight();
        //             var offsetTop = $('#tab-' + activeTab).offset().top;
        //             $('html, body').animate({
        //                 scrollTop: offsetTop - headerHeight
        //             }, 0);
        //         }
        //     }, 0); 
        // }

        // handle pubs presentations filter
        // document.querySelector('#filter_dropdown').addEventListener('change', function() {
        //     var filterTerm = this.value;
        //     console.log('filterTerm', filterTerm);
        //     var apiUrl = '/wp-json/myplugin/v1/filter-posts?filter_term=' + filterTerm;
        //     fetch(apiUrl)
        //         .then(response => response.text())
        //         .then(html => {
        //             document.querySelector('.pubs-presentations-feed').innerHTML = html;
        //         })
        //         .catch(error => {
        //             console.error('Error fetching filtered posts:', error);
        //         });
        // });
        

    }); // document ready
})(jQuery);
